import { createModel } from "nyax";
import { Package } from "src/models/package";
import { createItemsEntityModel } from "src/store/itemsEntity";

export const PackageEntityModel = createModel(
  class extends createItemsEntityModel<Package>((item) => item.id) {
    public selectors() {
      return {
        ...super.selectors(),
      };
    }
  }
);
